export const STRIPE_REQUEST = 'stripe/STRIPE_REQUEST';
export const STRIPE_REFUND_REQUEST = 'stripe/STRIPE_REFUND_REQUEST';
export const STRIPE_TRANSACTION_REQUEST = 'stripe/STRIPE_TRANSACTION_REQUEST';
export const STRIPE_REQUEST_FAIL = 'stripe/STRIPE_REQUEST_FAIL';
export const STRIPE_RESPONSE = 'stripe/STRIPE_RESPONSE';
export const STRIPE_TRANSACTION_RESPONSE = 'stripe/STRIPE_TRANSACTION_RESPONSE';
export const HIDE_MODAL = 'stripe/HIDE_MODAL';
